import { FC } from 'react';
import { useIntl } from 'react-intl';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { ExternalLink, FeatureFlags, Icon } from '@app/components';
import { useSearchContext } from '@app/contexts';
import { Feature } from '@app/constants';

const cnBem = createBemBlockBuilder(['searchResultsPage']);

export const PassthroughLink: FC = () => {
  const { $t } = useIntl();
  const {
    state: { query },
    searchOption,
  } = useSearchContext();

  return (
    <FeatureFlags
      flagsToMatch={[{ name: Feature.passthroughlink }]}
      renderOn={flags => (
        <div
          className={cnBem('__passthrough-link')}
          data-auto="passthrough-link"
        >
          {$t(
            {
              id: 'searchResults.searchConsortia',
              defaultMessage:
                'Search for <i>"{term}"</i> across <a>{consortiaName}</a>',
            },
            {
              term: query,
              consortiaName: flags?.[0]?.config?.consortiaName as string,
              i: chunks => <i>{chunks}</i>,
              a: chunks => (
                <>
                  <ExternalLink
                    href={`${
                      flags?.[0]?.config?.consortiaLink as string
                    }search?option=${searchOption}&query=${query}`}
                  >
                    {chunks}
                  </ExternalLink>
                  <Icon icon={faExternalLink} />
                </>
              ),
            }
          )}
        </div>
      )}
    />
  );
};
